import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class DeliassorterrorService {
  private apiUrl = '/spring/ships/deliassorterror';

  constructor(
    private http: HttpService) { }

  get(): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl;
    return this.http.get(url);
  }



  put(
    shiphId: number,
    postCd: string,
    duplicatetypeCd: string,
    postsubCd: string,
    updprogramCd: string
  ): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl;
    const jsonInput = {
      shiphId: shiphId,
      postCd: postCd,
      duplicatetypeCd: duplicatetypeCd,
      postsubCd: postsubCd,
      updprogramCd: updprogramCd
    };
    return this.http.put(url, jsonInput);
  }




}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/deli-assort-error/deli-assort-error.service.ts